import { createSlice } from '@reduxjs/toolkit';

/**
 * Which change-of-circumstance record a link asked the register to open on.
 *
 * The guided card offers "Approve COC-1" and cannot run it — approving is the
 * moment a fee moves, and the evidence prompt and waiver reason that guard it
 * live on the CoC tab. So the link navigates there instead, and this carries
 * the one thing the URL does not: *which record*. Landing on a register of six
 * collapsed cards and hunting for COC-1 is the confusion this removes.
 *
 * **Not a URL parameter.** A highlight's natural lifetime is "until consumed",
 * and in the URL it survives a reload and a back-navigation — so a bookmark
 * would re-open a record days later, and stopping that means stripping the
 * parameter with a replace-navigate. Held here it is one-shot by construction,
 * and it is the same panel-to-tab handoff `chatMessage` already makes.
 */
const cocFocusSlice = createSlice({
  name: 'cocFocus',
  initialState: {
    cocId: null,
  },
  reducers: {
    focusCocRecord: (state, action) => {
      state.cocId = action.payload || null;
    },
    /* Cleared by whoever acted on it, so a second visit to the tab does not
       re-open a card the reader has since collapsed themselves. */
    clearCocFocus: (state) => {
      state.cocId = null;
    },
  },
});

export const { focusCocRecord, clearCocFocus } = cocFocusSlice.actions;

export const cocFocusData = (state) => state.cocFocus;
export default cocFocusSlice.reducer;
